import { useNavigate, useParams } from "react-router-dom";
import { useStore } from "@/lib/theme";
import { useAuth } from "@/lib/auth";
import OtpLogin from "@/components/OtpLogin";
import { Card } from "@/components/ui/card";

export default function StorefrontLogin() {
  const { slug } = useParams();
  const { tenant } = useStore();
  const { setUser, setTenant } = useAuth();
  const nav = useNavigate();
  const brand = tenant?.branding?.primary_color || "#0F172A";
  return (
    <div className="max-w-md mx-auto px-4 py-10">
      <Card className="t-card t-surface p-0 overflow-hidden">
        {tenant?.branding?.hero_image_url && <img src={tenant.branding.hero_image_url} alt="" className="w-full h-32 object-cover" />}
        <div className="p-1">
          <OtpLogin
            scope="storefront"
            tenantSlug={slug}
            role="customer"
            brandColor={brand}
            title={`Sign in to ${tenant?.name}`}
            subtitle="Phone-OTP login. Test phone 9000099999"
            testIdPrefix="customer-login"
            onSuccess={(data) => {
              setUser(data.user);
              setTenant(data.tenant);
              nav(`/t/${slug}/account`);
            }}
          />
        </div>
      </Card>
    </div>
  );
}
